import ReleaseThree from "../mockData/images/releases/3.jpg"
import ReleaseFive from "../mockData/images/releases/5.jpg"
import ReleaseTen from "../mockData/images/releases/10.jpg"
import ReleaseSixteen from "../mockData/images/releases/16.jpg"

const mockAccountingReportsData = [
    {
        "id": 104,
        "period": "Aug 2021 - Dec 2021",
        "release": "Melodic Harmony",
        "release_artwork": ReleaseTen,
        "royalties": "195.68 €",
        "costs": "-195.0 €",
        "net_revenue": "0.68 €",
        "label_revenue": "0.34 €",
        "shareholders_revenue": "0.34 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2021-12-03T15:06:20.194038Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 219,
                "accounting_report": 104,
                "track": "Melodic Harmony",
                "royalties": "195.68 €",
                "costs": "-195.0 €",
                "label_revenue": "0.34 €",
                "shareholders_revenue": "0.34 €",
                "net_revenue": "0.68 €",
                "store_wise_breakdown": {
                    "Tidal": "1.24140",
                    "Deezer": "5.51638",
                    "Spotify": "91.52836",
                    "YouTube": "62.36399",
                    "Beatport": "10.87796",
                    "Facebook": "3.88210",
                    "Instagram": "5.29064",
                    "SoundCloud": "6.10915",
                    "TIM Italia": "1.64877",
                    "Other Stores": "1.52478",
                    "Amazon Unlimited": "5.69257"
                },
                "territory_wise_breakdown": {
                    "Italy": "34.54017",
                    "Spain": "10.16411",
                    "France": "9.52622",
                    "Belgium": "6.82487",
                    "Germany": "41.67685",
                    "Hungary": "8.15814",
                    "Netherlands": "10.65534",
                    "Switzerland": "6.12877",
                    "Other Countries": "1.52478",
                    "United States of America": "13.25411",
                    "United Kingdom of Great Britain & Northern Ireland": "10.98149"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 377,
                        "accounting_report_item": 219,
                        "revenue_share_holder": "Test Artist",
                        "revenue": "0.14 €"
                    },
                    {
                        "id": 378,
                        "accounting_report_item": 219,
                        "revenue_share_holder": "John Doe",
                        "revenue": "0.2 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 191,
                "accounting_report": 104,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": true,
                "revenue": "0.2 €",
                "report_pdf": ""
            },
            {
                "id": 190,
                "accounting_report": 104,
                "revenue_share_holder": "Test Artist",
                "email": "vujeva.luka@gmail.com",
                "email_sent": true,
                "revenue": "0.14 €",
                "report_pdf": ""
            }
        ]
    },
    {
        "id": 108,
        "period": "Jun 2021 - May 2022",
        "release": "Melodic Harmony",
        "release_artwork": ReleaseTen,
        "royalties": "420.31 €",
        "costs": "0.0 €",
        "net_revenue": "420.31 €",
        "label_revenue": "210.15 €",
        "shareholders_revenue": "210.15 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2022-09-07T13:24:44.157403Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 224,
                "accounting_report": 108,
                "track": "Melodic Harmony",
                "royalties": "420.31 €",
                "costs": "0.0 €",
                "label_revenue": "210.15 €",
                "shareholders_revenue": "210.15 €",
                "net_revenue": "420.31 €",
                "store_wise_breakdown": {
                    "Tidal": "2.28502",
                    "Deezer": "10.80522",
                    "Spotify": "171.09941",
                    "YouTube": "167.40652",
                    "BOOM APP": "4.94682",
                    "Beatport": "25.22146",
                    "Facebook": "1.65096",
                    "Instagram": "7.40944",
                    "SoundCloud": "12.68924",
                    "Other Stores": "4.22762",
                    "Amazon Unlimited": "12.56601"
                },
                "territory_wise_breakdown": {
                    "Italy": "72.20486",
                    "Spain": "21.34447",
                    "France": "19.51698",
                    "Belgium": "16.09816",
                    "Germany": "93.19914",
                    "Hungary": "14.88873",
                    "Netherlands": "20.94152",
                    "Switzerland": "11.68893",
                    "Other Countries": "4.22762",
                    "United States of America": "29.30504",
                    "United Kingdom of Great Britain & Northern Ireland": "26.08398"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 385,
                        "accounting_report_item": 224,
                        "revenue_share_holder": "Test Artist",
                        "revenue": "84.06 €"
                    },
                    {
                        "id": 386,
                        "accounting_report_item": 224,
                        "revenue_share_holder": "John Doe",
                        "revenue": "126.09 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 198,
                "accounting_report": 108,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": false,
                "revenue": "126.09 €",
                "report_pdf": ""
            },
            {
                "id": 197,
                "accounting_report": 108,
                "revenue_share_holder": "Test Artist",
                "email": "vujeva.luka@gmail.com",
                "email_sent": true,
                "revenue": "84.06 €",
                "report_pdf": ""
            }
        ]
    },
    {
        "id": 106,
        "period": "Nov 2020 - Nov 2020",
        "release": "Melodic Harmony",
        "release_artwork": ReleaseTen,
        "royalties": "238.28 €",
        "costs": "0.0 €",
        "net_revenue": "238.28 €",
        "label_revenue": "119.14 €",
        "shareholders_revenue": "119.14 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2022-01-12T17:43:47.510839Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 221,
                "accounting_report": 106,
                "track": "Melodic Harmony",
                "royalties": "238.28 €",
                "costs": "0.0 €",
                "label_revenue": "119.14 €",
                "shareholders_revenue": "119.14 €",
                "net_revenue": "238.28 €",
                "store_wise_breakdown": {
                    "Amazon": "1.53372",
                    "Deezer": "6.91741",
                    "Spotify": "68.60495",
                    "YouTube": "110.61607",
                    "BOOM APP": "1.35026",
                    "Beatport": "13.78496",
                    "Facebook": "7.03246",
                    "Instagram": "11.91985",
                    "SoundCloud": "10.99062",
                    "Other Stores": "1.40288",
                    "Amazon Unlimited": "4.12333"
                },
                "territory_wise_breakdown": {
                    "Italy": "47.37872",
                    "Spain": "13.55661",
                    "France": "14.23827",
                    "Germany": "48.28753",
                    "Hungary": "7.30649",
                    "Australia": "7.54292",
                    "Netherlands": "8.69264",
                    "Switzerland": "7.35632",
                    "Other Countries": "1.40288",
                    "United States of America": "15.94110",
                    "United Kingdom of Great Britain & Northern Ireland": "11.78999"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 381,
                        "accounting_report_item": 221,
                        "revenue_share_holder": "Test Artist",
                        "revenue": "47.66 €"
                    },
                    {
                        "id": 382,
                        "accounting_report_item": 221,
                        "revenue_share_holder": "John Doe",
                        "revenue": "71.48 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 194,
                "accounting_report": 106,
                "revenue_share_holder": "Test Artist",
                "email": "vujeva.luka@gmail.com",
                "email_sent": false,
                "revenue": "47.66 €",
                "report_pdf": "",
            },
            {
                "id": 195,
                "accounting_report": 106,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": true,
                "revenue": "71.48 €",
                "report_pdf": "",
            }
        ]
    },
    {
        "id": 105,
        "period": "Sep 2020 - Aug 2021",
        "release": "Mystic Voyage",
        "release_artwork": ReleaseThree,
        "royalties": "309.11 €",
        "costs": "0.0 €",
        "net_revenue": "309.11 €",
        "label_revenue": "123.64 €",
        "shareholders_revenue": "185.46 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2021-12-15T16:10:04.440792Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 220,
                "accounting_report": 105,
                "track": "New Music",
                "royalties": "309.11 €",
                "costs": "0.0 €",
                "label_revenue": "123.64 €",
                "shareholders_revenue": "185.46 €",
                "net_revenue": "309.11 €",
                "store_wise_breakdown": {
                    "Deezer": "5.38527",
                    "iTunes": "2.69557",
                    "Spotify": "104.76756",
                    "YouTube": "76.73387",
                    "Beatport": "17.12157",
                    "Facebook": "23.01547",
                    "Instagram": "28.44981",
                    "SoundCloud": "1.92638",
                    "Apple Music": "26.80761",
                    "Other Stores": "5.38257",
                    "Amazon Unlimited": "16.82075"
                },
                "territory_wise_breakdown": {
                    "Italy": "46.77378",
                    "Spain": "19.72759",
                    "France": "11.28001",
                    "Germany": "60.09978",
                    "Hungary": "8.68613",
                    "Australia": "9.93205",
                    "Netherlands": "9.44840",
                    "Switzerland": "9.98584",
                    "Other Countries": "5.38257",
                    "United States of America": "31.06452",
                    "United Kingdom of Great Britain & Northern Ireland": "18.16994"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 379,
                        "accounting_report_item": 220,
                        "revenue_share_holder": "John Doe",
                        "revenue": "123.64 €"
                    },
                    {
                        "id": 380,
                        "accounting_report_item": 220,
                        "revenue_share_holder": "Klark Kent",
                        "revenue": "61.82 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 193,
                "accounting_report": 105,
                "revenue_share_holder": "Klark Kent",
                "email": "test@test.io",
                "email_sent": false,
                "revenue": "61.82 €",
                "report_pdf": "",
            },
            {
                "id": 192,
                "accounting_report": 105,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": false,
                "revenue": "123.64 €",
                "report_pdf": "",
            }
        ]
    },
    {
        "id": 103,
        "period": "Sep 2020 - Aug 2021",
        "release": "Serene Odyssey",
        "release_artwork": ReleaseSixteen,
        "royalties": "871.89 €",
        "costs": "0.0 €",
        "net_revenue": "871.89 €",
        "label_revenue": "435.94 €",
        "shareholders_revenue": "435.94 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2021-12-03T12:28:02.205202Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 218,
                "accounting_report": 103,
                "track": "Serene Odyssey",
                "royalties": "871.89 €",
                "costs": "0.0 €",
                "label_revenue": "435.94 €",
                "shareholders_revenue": "435.94 €",
                "net_revenue": "871.89 €",
                "store_wise_breakdown": {
                    "Deezer": "94.44764",
                    "iTunes": "15.45610",
                    "Spotify": "486.86544",
                    "YouTube": "101.66542",
                    "Beatport": "99.90673",
                    "Instagram": "3.99181",
                    "SoundCloud": "18.80752",
                    "Traxsource": "10.37772",
                    "Apple Music": "22.65127",
                    "Other Stores": "10.79637",
                    "Amazon Unlimited": "6.92242"
                },
                "territory_wise_breakdown": {
                    "Italy": "35.66258",
                    "Spain": "31.80214",
                    "France": "75.92399",
                    "Belgium": "25.35055",
                    "Germany": "251.88746",
                    "Australia": "29.33624",
                    "Netherlands": "49.90699",
                    "Switzerland": "27.95274",
                    "Other Countries": "10.79637",
                    "United States of America": "118.11443",
                    "United Kingdom of Great Britain & Northern Ireland": "60.46523"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 376,
                        "accounting_report_item": 218,
                        "revenue_share_holder": "John Doe",
                        "revenue": "435.94 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 189,
                "accounting_report": 103,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": true,
                "revenue": "435.94 €",
                "report_pdf": "",
            }
        ]
    },
    {
        "id": 102,
        "period": "Sep 2020 - Aug 2021",
        "release": "Echoing Paradise",
        "release_artwork": ReleaseFive,
        "royalties": "273.28 €",
        "costs": "-75.0 €",
        "net_revenue": "198.28 €",
        "label_revenue": "99.14 €",
        "shareholders_revenue": "99.14 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2021-12-02T10:59:32.804598Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 217,
                "accounting_report": 102,
                "track": "Echoing Paradise",
                "royalties": "273.28 €",
                "costs": "-75.0 €",
                "label_revenue": "99.14 €",
                "shareholders_revenue": "99.14 €",
                "net_revenue": "198.28 €",
                "store_wise_breakdown": {
                    "Deezer": "3.10124",
                    "Spotify": "175.76253",
                    "YouTube": "75.45368",
                    "Beatport": "12.24382",
                    "SoundCloud": "6.36832",
                    "Traxsource": "0.35086"
                },
                "territory_wise_breakdown": {
                    "Italy": "12.59276",
                    "Spain": "9.98411",
                    "France": "10.70499",
                    "Belgium": "11.97977",
                    "Germany": "82.22040",
                    "Hungary": "8.68016",
                    "Australia": "11.63363",
                    "Netherlands": "18.75576",
                    "United States of America": "19.34290",
                    "United Kingdom of Great Britain & Northern Ireland": "21.31646"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 374,
                        "accounting_report_item": 217,
                        "revenue_share_holder": "John Doe",
                        "revenue": "49.57 €"
                    },
                    {
                        "id": 375,
                        "accounting_report_item": 217,
                        "revenue_share_holder": "Klark Kent",
                        "revenue": "49.57 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 188,
                "accounting_report": 102,
                "revenue_share_holder": "Klark Kent",
                "email": "test@test.io",
                "email_sent": false,
                "revenue": "49.57 €",
                "report_pdf": "",
            },
            {
                "id": 187,
                "accounting_report": 102,
                "revenue_share_holder": "John Doe",
                "email": "test@test.io",
                "email_sent": true,
                "revenue": "49.57 €",
                "report_pdf": "",
            }
        ]
    },
    {
        "id": 101,
        "period": "Aug 2020 - Jul 2021",
        "release": "Serene Odyssey",
        "release_artwork": ReleaseSixteen,
        "royalties": "1519.23 €",
        "costs": "-110.0 €",
        "net_revenue": "1409.23 €",
        "label_revenue": "611.06 €",
        "shareholders_revenue": "798.17 €",
        "status": 2,
        "created_by": 12,
        "date_created": "2021-11-30T17:43:28.702722Z",
        "report_pdf": "",
        "accounting_report_items": [
            {
                "id": 215,
                "accounting_report": 101,
                "track": "Serene Odyssey",
                "royalties": "703.69 €",
                "costs": "-80.0 €",
                "label_revenue": "218.29 €",
                "shareholders_revenue": "405.4 €",
                "net_revenue": "623.69 €",
                "store_wise_breakdown": {
                    "Tilda": "99.11000",
                    "Deezer": "45.19530",
                    "Spotify": "114.06078",
                    "YouTube": "51.76544",
                    "Beatport": "85.23847",
                    "Facebook": "16.05244",
                    "SoundCloud": "36.62000",
                    "Traxsource": "74.33000",
                    "Apple Music": "72.22021",
                    "Junodownload": "66.77000",
                    "Other Stores": "42.32776"
                },
                "territory_wise_breakdown": {
                    "Italy": "15.26824",
                    "Korea": "33.59068",
                    "France": "14.95348",
                    "Serbia": "67.41510",
                    "Germany": "170.70709",
                    "Kazakhstan": "11.11465",
                    "Switzerland": "82.96366",
                    "Other Countries": "42.32776",
                    "Russian Federation": "100.06388",
                    "United States of America": "116.05826",
                    "United Kingdom of Great Britain & Northern Ireland": "14.50106"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 372,
                        "accounting_report_item": 215,
                        "revenue_share_holder": "Max Mustermann",
                        "revenue": "405.4 €"
                    }
                ]
            },
            {
                "id": 216,
                "accounting_report": 101,
                "track": "Whispering Willows Mix",
                "royalties": "815.54 €",
                "costs": "-30.0 €",
                "label_revenue": "392.77 €",
                "shareholders_revenue": "392.77 €",
                "net_revenue": "785.54 €",
                "store_wise_breakdown": {
                    "UMA": "84.45000",
                    "Tilda": "72.81000",
                    "Deezer": "98.35000",
                    "Spotify": "122.62000",
                    "YouTube": "91.22000",
                    "Beatport": "62.17000",
                    "SoundCloud": "78.72000",
                    "Traxsource": "83.66000",
                    "Apple Music": "56.72000",
                    "Junodownload": "64.82000"
                },
                "territory_wise_breakdown": {
                    "Spain": "163.17000",
                    "France": "135.44000",
                    "Germany": "72.81000",
                    "United States of America": "184.79000",
                    "United Kingdom of Great Britain & Northern Ireland": "259.33000"
                },
                "shareholder_breakdowns": [
                    {
                        "id": 373,
                        "accounting_report_item": 216,
                        "revenue_share_holder": "Max Mustermann",
                        "revenue": "392.77 €"
                    }
                ]
            }
        ],
        "revenueshareholder_reports": [
            {
                "id": 186,
                "accounting_report": 101,
                "revenue_share_holder": "Max Mustermann",
                "email": "max@test.com",
                "email_sent": false,
                "revenue": "798.17 €",
                "report_pdf": "",
            }
        ]
    }
]
export default mockAccountingReportsData;